import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@shared/ui/components";

const faqs = [
  {
    question: "Есть ли пробный период?",
    answer: "Да! Вы можете попробовать сервис — 150 минут транскрипции всего за 99₽ на 7 дней."
  },
  {
    question: "Что происходит, если я превышу месячный лимит?",
    answer:
      "Если вы достигнете месячного лимита транскрипций, вам будет предложено обновить план. Или докупить дополнительные минуты."
  },
  {
    question: "Могу ли я отменить подписку?",
    answer:
      "Да, вы можете отменить подписку в любое время. У вас будет доступ к функциям вашего плана до конца текущего расчетного периода."
  },
  {
    question: "Какие языки вы поддерживаете?",
    answer:
      "Мы поддерживаем 99 языков. В выпадающем списке — 19 основных, включая русский, английский, испанский, французский, немецкий, китайский, японский и языки СНГ. Для остальных выберите автоопределение языка."
  }
];

export const PricingFaq: React.FC = () => {
  return (
    <section className="py-16 md:py-24 bg-background mb-5">
      <div className="container">
        <div className="mx-auto max-w-3xl">
          <div className="mb-12 text-center">
            <h2 className="text-3xl font-bold text-foreground mb-3 md:text-4xl">Часто задаваемые вопросы</h2>
            <p className="text-lg text-muted-foreground">Всё, что вам нужно знать о наших тарифах</p>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="border border-border rounded-lg px-6 mb-2">
                <AccordionTrigger className="text-left font-semibold text-foreground hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground">{faq.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
